<template>
  <!-- teste -->
  <li class="branch-item" @click="getInitialBranchData()">
    <div>
      <h3 class="branch-title">{{ branch.name }}</h3>
      <span class="branch-info"
        >{{ address.street }}, {{ address.number }},
        {{ address.neighborhood }}</span
      >
      <span class="branch-info">{{ address.city }} - {{ address.state }}</span>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  setActiveBranch,
  getAccessToken,
  setActiveMode,
} from "@/helpers/storage";
import { populateOrders, populateScheduledOrders } from "@/helpers/queries";

export default {
  name: "branch",
  props: {
    branch: {
      type: Object,
      required: true,
    },
  },
  computed: {
    address() {
      return this.branch.location.address;
    },
    accessToken: () => getAccessToken(),
    ...mapGetters(["getCompanyId"]),
  },
  methods: {
    async getInitialBranchData() {
      this.$emit("loading-branch-data", true);

      try {
        await populateOrders(
          this.$FeathersVuex.api,
          this.accessToken,
          this.getCompanyId,
          this.branch._id,
          16
        );

        await populateScheduledOrders(
          this.$FeathersVuex.api,
          this.accessToken,
          this.getCompanyId,
          this.branch._id,
          null
        );

        this.$emit("loading-branch-data", false);

        setActiveBranch(this.branch._id);

        this.sync();

        this.setMode("delivery");

        // só redirecionar pra essa pagina quando o outro modo estiver pronto
        // this.$router.push("/select-mode");
      } catch (e) {
        this.$emit("loading-branch-data", false);

        console.log("deu ruim");
        console.log(e);
      }
    },
    setMode(mode) {
      setActiveMode(mode);

      this.$router.push("/dashboard");
    },
    ...mapActions(["sync"]),
  },
};
</script>

<style lang="scss" scoped>
.branch-item {
  cursor: pointer;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #f9f9f9;
}

.branch-title {
  font-size: 1.125rem;
  font-weight: 300;
  color: $accent-color;
}

.branch-info {
  display: block;
  line-height: 1.5;
  color: $text-color;
  opacity: 0.6;
}
</style>
